import { render } from "./SliderImage.vue?vue&type=template&id=cb4ae784"
import script from "./SliderImage.vue?vue&type=script&lang=js"
export * from "./SliderImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__